/**
 * A member's way back (S3-20): what they turned off from links in emails. Theirs from the session, on
 * the server, and from Postgres.
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { get, postJson } from '../../api/httpClient';

export const fetchTurnedOffThunk = createAsyncThunk(
  'TurnedOffEmails/fetch',
  (_, { rejectWithValue }) =>
    get('/api/email/turned-off')
      .then(response => response.data.data)
      .catch(() => rejectWithValue('failed'))
);

export const turnBackOnThunk = createAsyncThunk(
  'TurnedOffEmails/turnBackOn',
  ({ wording, scopeId }, { rejectWithValue }) =>
    postJson('/api/email/turned-off/turn-back-on', { wording, scopeId }).catch(() =>
      rejectWithValue('failed')
    )
);

const initialState = { rows: [], loadFailed: false, savingRow: null, saveFailed: false };
const sameRow = (row, { wording, scopeId }) => row.wording === wording && row.scopeId === scopeId;

const turnedOffEmailsSlice = createSlice({
  name: 'TurnedOffEmails',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTurnedOffThunk.pending, state => {
        state.loadFailed = false;
        state.saveFailed = false;
      })
      .addCase(fetchTurnedOffThunk.rejected, state => {
        state.loadFailed = true;
      })
      .addCase(fetchTurnedOffThunk.fulfilled, (state, action) => {
        state.rows = action.payload || [];
      })
      .addCase(turnBackOnThunk.pending, (state, action) => {
        state.savingRow = action.meta.arg;
        state.saveFailed = false;
      })
      .addCase(turnBackOnThunk.fulfilled, (state, action) => {
        state.savingRow = null;
        state.rows = state.rows.filter(row => !sameRow(row, action.meta.arg));
      })
      .addCase(turnBackOnThunk.rejected, state => {
        state.savingRow = null;
        state.saveFailed = true;
      });
  },
});

export default turnedOffEmailsSlice.reducer;

export const loadData = () => dispatch => dispatch(fetchTurnedOffThunk());
